// More complex formatting, with links: https://formatjs.io/docs/react-intl/components#rich-text-formatting

// https://eportugal.gov.pt/en/servicos/ativar-a-chave-movel-digital

// This is the default language, so we don't need to use the `Translation` type in here
export const ptPT = {
  'page.home.title': 'Mind the Coin | Registo',
  'page.home.description': 'Registo para clientes Mind the Coin',
  'page.status.title': 'Mind the Coin | Registo | Estado da verificação',
  'page.additionalInformation.title': 'Mind the Coin | Registo de identidade | Informações adicionais',
  'login.chaveMovel.info':
    'A chave móvel digital pode ser ativada por residentes em Portugal. Instruções para ativar podem ser encontradas <link>no site do governo</link>.',
  'login.chaveMovel.infoLink':
    'https://www.autenticacao.gov.pt/cmd-pedido-chave',
  'login.data.whyDoWeCollectTitle': 'Por que recolhemos os seus dados?',
  'login.data.whyDoWeCollect':
    'Os dados recolhidos serão única e exclusivamente processados no âmbito da <link>Lei n.º 83/2017</link>, e nunca para efeitos de marketing ou comunicação. Em harmonia com o artigo 24.º, ponto 1 da mesma Lei, é obrigatória a recolha das seguintes informações:',
  'login.data.whyDoWeCollectLink':
    'https://dre.pt/dre/legislacao-consolidada/lei/2017-108024643',
  'login.data.photo': 'Fotografia',
  'login.data.fullName': 'Nome completo',
  'login.data.signature': 'Assinatura',
  'login.data.birthDate': 'Data de nascimento',
  'login.data.nationality':
    'Nacionalidade',
  'login.data.documentEntity':
    'Tipo, número, data de validade e entidade emitente do documento de identificação',
  'login.data.nif':
    'Número de identificação fiscal',
  'login.data.occupation': 'Profissão e entidade patronal',
  'login.data.address':
    'Endereço completo da residência permanente (se aplicável)',
  'login.data.placeOfBirth': 'Naturalidade',
  'login.data.otherNationalities':
    'Outras nacionalidades',
  'login.data.phoneNumberInfo':
    'Também recolhemos o número de telemóvel, de forma a que possa utilizar as nossas máquinas.',
  'login.main.chaveMovel':
    'Selecione uma das seguintes opções para proceder com o registo.',
  'login.main.cookieInfo':
    '<b>Informacão sobre cookies:</b> Ao continuar, concorda que guardemos no browser dados sobre o seu estado de autenticação. Esta informação é eliminada assim que fechar a janela e terá que fazer login novamente para ver o estado do seu registo.',
  'login.gov.buttonTitle': 'Autenticação Gov.pt',
  'login.form.buttonTitle': 'Formulário',
  'status.inProgress.text': 'Estamos a verificar a sua identidade. Receberá uma mensagem no seu telemóvel assim que o processo estiver completo.',
  'status.inProgress.secondary': 'O tempo médio de espera são duas horas, mas poderá demorar até um dia.',
  'status.verified.text': 'A sua identidade foi verificada!',
  'status.verified.iconTitle': 'Identidade verificada',
  'status.verified.secondary': 'Pode utilizar os serviços da <b>Mind the Coin</b> sem limitações, usando o seu número de telefone.',
  'status.error.text': 'Ocorreu um erro ao verificar a sua identidade.',
  'status.error.iconTitle': 'Erro ao verificar identidade',
  'status.error.secondary': 'Para mais informações, contacte a nossa linha de suporte em <b>{email}</b> ou via telefone em <b>{phoneNumber}</b>.',
  'status.apiError.text': 'Não foi possível carregar o estado actual da sua verificação de identidade. Por favor actualize a página.',
  'status.apiError.iconTitle': 'Erro ao carregar o estado',
  'status.apiError.secondary': 'Se o problema persistir, pode contactar a nossa linha de suporte em <b>{email}</b> ou via telefone em <b>{phoneNumber}</b>.',
  'moreInfo.text': 'Obrigada por se registar. Para finalizar, agradecemos que forneça os seguintes detalhes.',
  'moreInfo.fields.occupation': 'Profissão*',
  'moreInfo.fields.occupation.help': 'Se estiver desempregado/a ou reformado/a, pf. indique também a última profissão exercida.',
  'moreInfo.fields.employer': 'Entidade patronal*',
  'moreInfo.fields.employer.help': 'Se estiver desempregado/a ou reformado/a, pf. indique a última entidade patronal.',
  'moreInfo.fields.businessArea': 'Indústria*',
  'moreInfo.fields.businessArea.help': 'Indique o seu setor de atividade. Se desempregado/a ou reformado/a, refira o último setor em que trabalhou.',
  'moreInfo.fields.businessRevenue': 'Nível de rendimento anual pessoal bruto*',
  'moreInfo.fields.businessRevenue.help': 'Selecione o intervalo que melhor representa o seu rendimento anual bruto.',
  'moreInfo.fields.highRiskCountry': 'Países de alto risco',
  'moreInfo.fields.highRiskCountry.help': 'Se tiver negócios ou ligações pessoais com países de alto risco, pf. indique quais.',
  'moreInfo.fields.relationshipPurpose': 'Motivo do registo*',
  'moreInfo.fields.relationshipPurpose.help': 'Indique o principal motivo para o seu registo na plataforma',
  'moreInfo.fields.placeOfBirth': 'Naturalidade*',
  'moreInfo.fields.placeOfBirth.help': 'Localidade onde nasceu',
  'moreInfo.fields.otherNationalities': 'Outras nacionalidades',
  'moreInfo.fields.otherNationalities.help': 'Se aplicável',
  'moreInfo.fields.otherNationalities.info': 'Nacionalidades não constantes do documento de identificação ligado à chave móvel digital (se houver).',
  'moreInfo.fields.address.info': 'Endereço completo da residência permanente - Preencha apenas se for diferente do domicílio fiscal.',
  'moreInfo.fields.address.title': 'Endereço permanente (se diferente do fiscal)',
  'moreInfo.fields.address.line1': 'Primeira Linha',
  'moreInfo.fields.address.line2': 'Segunda Linha',
  'moreInfo.fields.address.postalCode': 'Código postal',
  'moreInfo.fields.address.city': 'Cidade',
  'moreInfo.fields.address.country': 'País',
  'moreInfo.buttons.submit': 'Enviar',
  'moreInfo.status.success': "Tudo em ordem! Será enviado para uma página onde pode ver o estado atual do seu registo {countdown, plural, one {num segundo} other {em # segundos}}.",
  'moreInfo.status.error': 'Houve um erro ao enviar os dados. Por favor tente novamente.',
  'validation.stringLength': 'O campo "{fieldName}" deve ter entre {min} e {max} caracteres.',
  'form.fields.countryDropdown.multiplePlaceholder': 'Escolha um ou mais países',
  'form.fields.countryDropdown.singlePlaceholder': 'Escolha um país',
  'form.fields.countryDropdown.emptySearch': 'País não encontrado. Está escrito em Português?',
  'form.fields.businessAreaDropdown.multiplePlaceholder': 'Selecione um ou mais ramos de negócio',
  'form.fields.businessAreaDropdown.singlePlaceholder': 'Selecione um ramo de negócio',
  'form.fields.businessAreaDropdown.emptySearch': 'Ramo de negócio não encontrado. Está escrito em Português?',
  'form.fields.businessRevenueDropdown.multiplePlaceholder': 'Selecione o intervalo de receita anual do seu empregador',
  'form.fields.businessRevenueDropdown.singlePlaceholder': 'Selecione o intervalo de receita anual do seu empregador',
  'form.fields.businessRevenueDropdown.emptySearch': 'Intervalo de receita anual não encontrado.', 
  'form.fields.highRiskCountryDropdown.singlePlaceholder': 'Selecione um ou mais países',
  'form.fields.highRiskCountryDropdown.multiplePlaceholder': 'Selecione um ou mais países',
  'form.fields.highRiskCountryDropdown.emptySearch': 'Não encontrado', 
  'form.fields.mandatory': 'Campo obrigatório.',
  'authorisation.notAuthorised.title': 'Não autorizado',
  'authorisation.error': ' Ocorreu um problema ao iniciar sessão. Por favor, volte atrás e tente novamente. Se o problema persistir, entre em contacto connosco através de {email} ou por telefone em {phoneNumber}.',
  'common.close': 'Fechar',
  'common.logout': 'Sair',
  'common.moreInfo': 'Mais informações',
  'common.customerServiceEmail': 'suporte@mindthecoin.com',
  'common.customerServicePhoneNumber': '912 125 732',
  'common.backToHome': 'Voltar à página inicial',
  'errors.404.title': 'Página não encontrada',
  'errors.404.description': 'A página que procura não existe. Por favor, volte à página inicial e tente novamente.',
}



export const businessAreasPtPT = [
  'Aeroespacial e Defesa',
  'Agricultura e Pecuária',
  'Alimentos e Bebidas',
  'Apostas e Jogos de Azar',
  'Artes e Entretenimento',
  'Ativos virtuais e Criptomoedas',
  'Automóvel',
  'Bens de Consumo e Serviços',
  'Biotecnologia',
  'Comércio por Grosso',
  'Construção',
  'Contabilidade e Finanças',
  'Desporto',
  'Educação',
  'Energia e Utilidades',
  'Farmacêutica',
  'Governo e Administração Pública',
  'Hospitalidade e Turismo',
  'Imobiliário',
  'Manufatura',
  'Mídia e Radiodifusão',
  'Mineração e Metais',
  'Moda e Vestuário',
  'Publicidade e Marketing',
  'Químicos',
  'Retalho',
  'Saúde e Assistência Social',
  'Seguros',
  'Sem fins lucrativos',
  'Serviços Ambientais',
  'Serviços de Engenharia',
  'Serviços Jurídicos',
  'Serviços Veterinários',
  'Tecnologia da Informação e Serviços',
  'Telecomunicações',
  'Transporte e Logística',
]
